'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { WindowDimensionsContext } from '../../context/WindowDimensionsContext';

const WindowDimensionsProvider = ({
  children
}) => {
  const [dimensions, setDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
    deviceWidth: window.screen.width,
    deviceHeight: window.screen.height
  });
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth !== dimensions.width || window.innerHeight !== dimensions.height || window.screen.width !== dimensions.deviceWidth || window.screen.height !== dimensions.deviceHeight) {
        setDimensions({
          width: window.innerWidth,
          height: window.innerHeight,
          deviceWidth: window.screen.width,
          deviceHeight: window.screen.height
        });
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [dimensions]);
  return /*#__PURE__*/_jsx(WindowDimensionsContext.Provider, {
    value: dimensions,
    children: children
  });
};

WindowDimensionsProvider.propTypes = {
  children: PropTypes.node
};
export default WindowDimensionsProvider;